// Libs
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from 'notistack';
import useLocalStorage from "use-local-storage";

// Components
import Item from "./Item/Item.jsx";
import Search from './Search.jsx';
import Header from "../Header/Header.jsx"

// Services
import { GET } from "../../services/Bridge.js"

// Style
import style from "./style.module.css"

const Main = ({ toggleWebLanguage, webLanguage, toggleTheme, webTheme, webText, logMeOut }) => {

  const navigate = useNavigate();

  const { enqueueSnackbar } = useSnackbar();

  const [selectedButton, setSelectedButton] = useState('abecedneVzostupne');
  const [smallFilterOpened, setSmallFilterOpened] = useState(false);
  const [itemList, setItemList] = useState(null);
  const [itemListSave, setItemListSave] = useState(null);
  const [itemInSearch, setItemInSearch] = useState("");
  // eslint-disable-next-line
  const [authenticated, setAuthenticated] = useLocalStorage("authenticated", localStorage.authenticated);

  useEffect(() => {

    const asyncFunction = async () => {

        try {
            const response = await GET("advertisements");

            // Short objects to default
            response.sort((a, b) => a.title.toLowerCase().localeCompare(b.title.toLowerCase()));

            setItemList(response);
            setItemListSave(response);

        } catch (error) {
            enqueueSnackbar(error, {
              variant: "error",
              autoHideDuration: 5000,
            });
        };
    };

    asyncFunction();


  // eslint-disable-next-line
  }, []);

  const addIdToMe = (buttonName) => {
    setSelectedButton(buttonName);
    const x = itemList;
    // eslint-disable-next-line
    switch (buttonName) {
      case "abecedneVzostupne":
        x.sort((a, b) => a.title.toLowerCase().localeCompare(b.title.toLowerCase()));
        setItemList(x);
        break;
      case "abecedneZostupne":
        x.sort((a, b) => b.title.toLowerCase().localeCompare(a.title.toLowerCase()));
        setItemList(x);
        break;
      case "odNajdrahsich":
        x.sort((a, b) => a.price - b.price);
        setItemList(x);
        break;
      case "odNajlacnejsich":
        x.sort((a, b) => b.price - a.price);
        setItemList(x);
        break;
      case "prvePridane":
        x.sort((a, b) => a.dateAdded - b.dateAdded);
        setItemList(x);
        break;
      case "poslednePridane":
        x.sort((a, b) => b.dateAdded - a.dateAdded);
        setItemList(x);
        break;
    }
  };

  const handleSearchResult = (result) => {

      if (result && result.value) {
          const filteredItem = itemList.filter(item => item.title.toLowerCase().includes(result.value.toLowerCase()));
          setItemList(filteredItem);
      } else setItemList(itemListSave);
  };

  return (
    <article className={style.page}>
      <Header
        webText={webText}
        toggleTheme={toggleTheme}
        toggleWebLanguage={toggleWebLanguage}
        webLanguage={webLanguage}
        webTheme={webTheme}
        authenticated={authenticated}
        logMeOut={logMeOut}
      />
      <main className={style.mainBox} authenticated={JSON.stringify(authenticated)}>

        <div className={style.offerText}>
          <h2>{webText.mainInfoTitle}</h2>
          <ul>
            <li><p>{webText.mainInfoLine1}</p></li>
            <li><p>{webText.mainInfoLine2}</p></li>
            <li><p>{webText.mainInfoLine3}</p></li>
            <li><p>{webText.mainInfoLine4}</p></li>
            <li><p>{webText.mainInfoLine5}</p></li>
            <li><p>{webText.mainInfoLine6}</p></li>
            <li><p>{webText.mainInfoLine7}</p></li>
          </ul>
        </div>

        <header className={style.carLoanHeader}>
          <h2>Financovanie</h2>
        </header>

        <div className={style.carLoan}>
          <ul>
            <li><p>MOŽNOSŤ POSKYTNUTIA VÝHODNÉHO AUTOÚVERU UŽ OD 10% AKONTÁCIE A TO BEZ POTREBY UZATVORENIA HAVARIJNÉHO POISTENIA.</p></li>
            <li><p>AUTOÚVER MOŽNÉ UZATVORIŤ AJ S RUČITEĽOM - SCHVÁLENIE CCA DO 2 HODÍN A TO AJ CEZ VÍKENDY.</p></li>
          </ul>
        </div>

        <header className={style.searchHeader}>
          <h2>{webText.searchFilter}</h2>
        </header>

        <div className={style.search}>
          <Search
            itemList={itemList}
            webText={webText}
            webLanguage={webLanguage}
            webTheme={webTheme}
            callback={handleSearchResult}
          />
        </div>

        <div className={style.smallSearch}>
          <input type="text" value={itemInSearch} onChange={event => setItemInSearch(event.target.value)}/>
          <svg viewBox="0 0 512 512" onClick={() => handleSearchResult({ value: itemInSearch })}>
            <path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"/>
          </svg>
        </div>

        <h2 className={style.filterHeader}>Filter</h2>

        <div className={style.filter}>
          <button
            className={selectedButton === 'abecedneVzostupne' ? style.selected : ''}
            onClick={() => addIdToMe('abecedneVzostupne')}
          >
            <p>{webText.shortByAlphabetically}</p>
            <svg style={{marginTop:"6px"}} viewBox="0 0 320 512">
              <path d="M182.6 137.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8H288c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z"/>
            </svg>
          </button>
          <button
            className={selectedButton === 'abecedneZostupne' ? style.selected : ''}
            onClick={() => addIdToMe('abecedneZostupne')}
          >
            <p>{webText.shortByAlphabetically}</p>
            <svg viewBox="0 0 320 512">
              <path d="M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z"/>
            </svg>
          </button>
          <button
            className={selectedButton === 'odNajdrahsich' ? style.selected : ''}
            onClick={() => addIdToMe('odNajdrahsich')}
          >
            <p>{webText.shortByPrice}</p>
            <svg style={{marginTop:"6px"}} viewBox="0 0 320 512">
              <path d="M182.6 137.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8H288c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z"/>
            </svg>
          </button>
          <button
            className={selectedButton === 'odNajlacnejsich' ? style.selected : ''}
            onClick={() => addIdToMe('odNajlacnejsich')}
          >
            <p>{webText.shortByPrice}</p>
            <svg viewBox="0 0 320 512">
              <path d="M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z"/>
            </svg>
          </button>
          <button
            className={selectedButton === 'prvePridane' ? style.selected : ''}
            onClick={() => addIdToMe('prvePridane')}
          >
            <p>{webText.shortByDateAdded}</p>
            <svg style={{marginTop:"6px"}} viewBox="0 0 320 512">
              <path d="M182.6 137.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8H288c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z"/>
            </svg>
          </button>
          <button
            className={selectedButton === 'poslednePridane' ? style.selected : ''}
            onClick={() => addIdToMe('poslednePridane')}
          >
            <p>{webText.shortByDateAdded}</p>
            <svg viewBox="0 0 320 512">
              <path d="M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z"/>
            </svg>
          </button>
        </div>

        <div className={style.smallFilter}>
          {selectedButton === 'abecedneVzostupne' && <p>Abecedne zostupne</p>}
          {selectedButton === 'abecedneZostupne' && <p>Abecedne vzostupne</p>}
          {selectedButton === 'odNajdrahsich' && <p>Od najnižšiej ceny</p>}
          {selectedButton === 'odNajlacnejsich' && <p>Od najvyššiej ceny</p>}
          {selectedButton === 'prvePridane' && <p>Od nojnovšie pridaného</p>}
          {selectedButton === 'poslednePridane' && <p>Od najstaršie pridaného</p>}
          <div id={smallFilterOpened ? style.smallFilterOpened : ""} className={style.dropDownFilterMenu}>
            <button
              className={selectedButton === 'abecedneVzostupne' ? style.selected : ''}
              style={{marginTop:"4px"}}
              onClick={() => {
                addIdToMe('abecedneVzostupne');
                setSmallFilterOpened(false);
              }}
            >Abecedne zostupne</button>
            <button
              className={selectedButton === 'abecedneZostupne' ? style.selected : ''}
              onClick={() => {
                addIdToMe('abecedneZostupne');
                setSmallFilterOpened(false);
              }}
            >Abecedne vzostupne</button>
            <button
              className={selectedButton === 'odNajdrahsich' ? style.selected : ''}
              onClick={() => {
                addIdToMe('odNajdrahsich');
                setSmallFilterOpened(false);
              }}
            >Od najnižšiej ceny</button>
            <button
              className={selectedButton === 'odNajlacnejsich' ? style.selected : ''}
              onClick={() => {
                addIdToMe('odNajlacnejsich');
                setSmallFilterOpened(false);
              }}
            >Od najvyššiej ceny</button>
            <button
              className={selectedButton === 'prvePridane' ? style.selected : ''}
              onClick={() => {
                addIdToMe('prvePridane');
                setSmallFilterOpened(false);
              }}
            >Od nojnovšie pridaného</button>
            <button
              className={selectedButton === 'poslednePridane' ? style.selected : ''}
              onClick={() => {
                addIdToMe('poslednePridane');
                setSmallFilterOpened(false);
              }}
            >Od najstaršie pridaného</button>
          </div>
          {!smallFilterOpened ?
            <svg viewBox="0 0 448 512" onClick={() => setSmallFilterOpened(prevStatus => !prevStatus)}>
              <path d="M201.4 374.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 306.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"/>
            </svg>
            :
            <svg viewBox="0 0 384 512" onClick={() => setSmallFilterOpened(prevStatus => !prevStatus)}>
              <path d="M376.6 84.5c11.3-13.6 9.5-33.8-4.1-45.1s-33.8-9.5-45.1 4.1L192 206 56.6 43.5C45.3 29.9 25.1 28.1 11.5 39.4S-3.9 70.9 7.4 84.5L150.3 256 7.4 427.5c-11.3 13.6-9.5 33.8 4.1 45.1s33.8 9.5 45.1-4.1L192 306 327.4 468.5c11.3 13.6 31.5 15.4 45.1 4.1s15.4-31.5 4.1-45.1L233.7 256 376.6 84.5z"/>
            </svg>
          }
        </div>

        {authenticated &&
          <button
            className={style.addNewButton}
            onClick={() => navigate("/addnewitem")}
          >Pridať</button>
        }

        <div className={authenticated ? style.adminContentList : style.advertisementsList}>
          {itemList === null ? <p>{webText.mainPageItemsLoading}</p> : itemList.length > 0 ?
            <>
              {itemList.map((item, index) => (
                  <Item
                    key={index}
                    item={item}
                    webText={webText}
                    webLanguage={webLanguage}
                    authenticated={authenticated}
                  />
              ))}
            </> : <p>{webText.noItemsForSale}</p>
          }
        </div>

      </main>
    </article>
  );
};

export default Main;